(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rerise-editorial-waitlist"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.rp-store-access')) {
      const dialog = document.querySelector('#password-form dialog');
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      return;
    }
    if (event.target.closest('#password-form .password-dialog__close-button')) {
      const dialog = document.querySelector('#password-form dialog');
      if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
      return;
    }
    const link = event.target.closest('.rp-page a[href^="#rp-"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    if (target instanceof HTMLDetailsElement) target.open = true;
    target.scrollIntoView({ block: 'start', behavior: 'auto' });
    const focus = target instanceof HTMLDetailsElement ? target.querySelector('summary') : target.querySelector('input[type="email"]');
    if (focus) focus.focus({ preventScroll: true });
    else if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
  });
  const openReriseAnchor = () => {
    if (!window.location.hash.startsWith('#rp-')) return;
    const target = document.getElementById(window.location.hash.slice(1));
    if (target instanceof HTMLDetailsElement) target.open = true;
  };
  window.addEventListener('hashchange', openReriseAnchor);
  openReriseAnchor();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rerise-wailist"] && !Shopify.designMode) return;
  try {
    
  function openRerisePrivacy() {
    const hash = window.location.hash;
    if (!hash.startsWith('#rr-privacy-')) return;
    const target = document.getElementById(hash.slice(1));
    if (target instanceof HTMLDetailsElement) target.open = true;
  }
  window.addEventListener('hashchange', openRerisePrivacy);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#rr-privacy-"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!(target instanceof HTMLDetailsElement)) return;
    event.preventDefault();
    target.open = true;
    target.scrollIntoView({ block: 'start' });
    target.querySelector('summary').focus({ preventScroll: true });
  });
  openRerisePrivacy();

  } catch(e) { console.error(e); }
})();
})();
